require('../../../retail/shared/wdh-legacy/intro-banner/js/base/component-intro-banner.js');
(function ($) {
  window.DGS.OnLoad.getInstance().register(function () {
    $('.component.intro-banner.negative-margin').each(function () {
      // to allow max-width 90% for image
      $('.negative-image', $(this)).removeAttr('style');

      // only check top pos for content-overflow
      $(this).addClass(window.DGS.Overflow.getInstance().skipBottomCheck);
    });
    $('.component.intro-banner.has-list-spot').each(function () {
      $('.outer-pos-wrapper', $(this)).append($('.intro-banner-list-spot-container', $(this)));
      if ($(this).hasClass('list-left')) {
        $('.intro-banner-list-spot-container', $(this)).insertBefore($('.inner-pos-wrapper', $(this)));
      }
    });
  });
})(jQuery);